/** Parffragrance quiz: strict perfume catalogue, exact gender tags and premium variant priority. */
(() => {
  'use strict';

  const Q = window.ParfQuizV5;
  if (!Q?.CatalogFinder || !Q?.MatchFinder || !Q?.Finder || Q.__catalogRulesV2) return;
  Q.__catalogRulesV2 = true;

  const locale = String(window.Shopify?.locale || document.documentElement.lang || '').toLowerCase();
  const isArabic = locale.startsWith('ar') || /^\/ar(?:\/|$)/i.test(window.location.pathname);

  /* Only true perfume products are eligible. This excludes oils, mists, creams and home scents. */
  Q.CatalogFinder.prototype.isPerfumeProduct = function isPerfumeProduct(product) {
    return String(product?.product_type || '').trim().toLowerCase() === 'perfume';
  };

  /* Gender comes from the catalogue's explicit gender tags, never from a product-name guess. */
  Q.CatalogFinder.prototype.detectGender = function detectGender(tags) {
    const exactTags = (Array.isArray(tags) ? tags : String(tags || '').split(','))
      .map((tag) => String(tag).trim().toLowerCase())
      .filter(Boolean);

    if (exactTags.includes('male') || exactTags.includes('men')) return 'men';
    if (exactTags.includes('female') || exactTags.includes('women')) return 'women';
    if (exactTags.includes('unisex') || exactTags.includes('genderless')) return 'unisex';

    return 'unknown';
  };

  /* Within the requested intensity, recommend the highest-priced available variant of each perfume. */
  Q.Finder.prototype.preferCandidate = function preferHighestPricedVariant(candidate, existing) {
    if (candidate.available !== existing.available) return candidate.available;
    if (candidate.price !== existing.price) return candidate.price > existing.price;
    return candidate.variantTitle.length > existing.variantTitle.length;
  };

  Q.MatchFinder.prototype.calculateResults = async function calculateResultsWithGenderPriority(forceReload = false) {
    this.setActiveState('loading');

    if (this.elements.loadingText) {
      this.elements.loadingText.textContent =
        this.catalogStatus === 'ready'
          ? 'Finding the fragrances that suit you best…'
          : 'Finishing your personalised fragrance matches…';
    }

    try {
      await this.ensureCatalogLoading(forceReload);
    } catch (_error) {
      this.showCatalogueError();
      return;
    }

    window.setTimeout(() => {
      const selectedGender = this.answers.gender?.value;

      const genderPriority = (candidate) => {
        if (selectedGender === 'men' || selectedGender === 'women') {
          if (candidate.gender === selectedGender) return 0;
          if (candidate.gender === 'unisex') return 1;
          return 2;
        }
        return 0;
      };

      const scored = this.getEligibleCandidates()
        .map((candidate) => this.scoreCandidate(candidate))
        .sort((a, b) => {
          const priorityDifference = genderPriority(a) - genderPriority(b);
          if (priorityDifference) return priorityDifference;
          return b.matchScore - a.matchScore
            || b.price - a.price
            || a.title.localeCompare(b.title);
        });

      const deduplicated = [];
      const usedKeys = new Set();

      scored.forEach((candidate) => {
        if (usedKeys.has(candidate.canonicalKey)) return;
        usedKeys.add(candidate.canonicalKey);
        deduplicated.push(candidate);
      });

      this.renderResults(deduplicated.slice(0, this.maxRecommendations));
    }, 260);
  };

  const originalPrettyGender = Q.Finder.prototype.prettyGender;
  Q.Finder.prototype.prettyGender = function prettyGenderWithUnknown(gender) {
    if (gender === 'unknown') return isArabic ? 'غير محدد' : 'Gender not specified';
    return originalPrettyGender.call(this, gender);
  };

  /* The card now shows the selected premium variant's exact price, not a misleading 'Starting from'. */
  const originalRenderProductCard = Q.Finder.prototype.renderProductCard;
  Q.Finder.prototype.renderProductCard = function renderProductCardWithSelectedVariantPrice(product, index) {
    return originalRenderProductCard.call(this, product, index)
      .replace('Starting from ', '');
  };
})();
